import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import './styles.css';
import NotFoundPage from './components/NotFound/NotFound';
import CovidDelInfo from './components/CovidDelInfo';
import CovidDelData from './components/CovidDelData';
import About from './components/About';
import LockdownServices from './components/LockdownServices';
import Infographics from './components/Infographics';
import PrivacyPolicy from './components/PrivacyPolicy';
import Wrapper from './views/Wrapper/Wrapper';
import importCss from './utils/importCss';

/*

export const loadRoute = {
  LandingPage: () => Promise.all([
    import('./components/LockdownServices'),
    importCss('LockdownServices'),
  ]),
};
*/

const routing = (
  <Router>
    <Wrapper>
      <Route exact path="/" component={CovidDelInfo} />
      <Route path="/lockdown-services" component={LockdownServices} />
      <Route path="/covid-delhi-data" component={CovidDelData} />
      <Route path="/about" component={About} />
      <Route path="/privacy-policy" component={PrivacyPolicy} />
      <Route path="/infographics" component={Infographics} />
    </Wrapper>
  </Router>
)

ReactDOM.render(routing, document.getElementById('root'));
